<template>
  <v-simple-table class="table-layout pa-4">
    <template v-slot:default>
      <thead>
        <tr>
          <th>Mã đơn hàng</th>
          <th>Loại đơn</th>
          <th>Ngày mua hàng</th>
          <th>Trạng Thái</th>
          <th>Sản Phẩm trong đơn hàng</th>
          <th>Tên con</th>
          <th>Số lượng</th>
          <th>Người phụ trách</th>
          <th>Giá trị đơn</th>
          <th>Doanh thu khởi tạo</th>
          <th v-if="checkAuthorization('order_update')">Thao tác</th>
        </tr>
      </thead>
      <template v-for="order in orders">
        <tbody class="bg-hover" :key="order.id">
          <tr>
            <td :rowspan="order.rowspan">{{order.code}}</td>
            <td :rowspan="order.rowspan">{{order.version === 1 ? "v1" : "v2"}}</td>
            <td :rowspan="order.rowspan">{{formatDate(order.createdAt)}}</td>
            <td :rowspan="order.rowspan">{{_.get(order, 'contactStatus.name', '')}}</td>
            <td>
              {{_.get(order, 'productComboList[0].name', '')}}
              <v-tooltip
                  bottom
                  v-if="_.get(order, 'productComboList[0].courseProductNames', []).length">
                <template v-slot:activator="{ on }">
                  <v-btn class="mr-2" icon small v-on="on">
                    <v-icon>mdi-information-variant</v-icon>
                  </v-btn>
                </template>
                <span>{{ _.get(order, 'productComboList[0].courseProductNames', []).join(', ') }}</span>
              </v-tooltip>
            </td>
            <td>{{_.get(order, 'productComboList[0].childName', '')}}</td>
            <td>{{_.get(order, 'productComboList[0].quantity', 0)}}</td>
            <td :rowspan="order.rowspan">{{_.get(order, 'user.fullName', '')}}</td>
            <td :rowspan="order.rowspan">{{formatPrice(_.get(order, 'totalPrice', 0))}}</td>
            <td :rowspan="order.rowspan">{{formatPrice(_.get(order, 'initTurnOver', 0))}}</td>
            <td v-if="checkAuthorization('order_update')" :rowspan="order.rowspan">
              <div class="action">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn @click="clickDetailOrder(order.id)" class="mr-2" icon small color="primary" v-on="on">
                      <v-icon>mdi-file-document</v-icon>
                    </v-btn>
                  </template>
                  <span>Xem chi tiết thông tin đơn hàng</span>
                </v-tooltip>
              </div>
            </td>
          </tr>
          <template v-for="(dataProduct, index) in order.productComboList">
            <tr v-if="index > 0" :key="order.id + 'product-list' + index">
              <td>
                {{_.get(dataProduct, 'name', '')}}
                <v-tooltip
                    bottom
                    v-if="_.get(dataProduct, 'courseProductNames', []).length">
                  <template v-slot:activator="{ on }">
                    <v-btn class="mr-2" icon small v-on="on">
                      <v-icon>mdi-information-variant</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ _.get(dataProduct, 'courseProductNames', []).join(', ') }}</span>
                </v-tooltip>
              </td>
              <td>{{_.get(dataProduct, 'childName', '')}}</td>
              <td>{{_.get(dataProduct, 'quantity', 0)}}</td>
            </tr>
          </template>
        </tbody>
      </template>
      <tfoot>
        <tr>
          <td colspan="7">
            <div style="margin-right: 20px;" class="d-flex align-center justify-end">
              <h3 class="mr-6">TỔNG GIÁ CÁC ĐƠN HÀNG:</h3> <span>{{formatPrice(totalPrice)}}</span>
            </div>
          </td>
        </tr>
      </tfoot>
    </template>
  </v-simple-table>
</template>
<script>
export default {
  props: {
    orders: {
      type: Array,
      default: () => []
    },
    totalPrice: {
      type: [Number, String],
      default: 0,
    },
  },
  methods: {
    clickDetailOrder(orderId) {
      // this.$router.push({
      //   name: 'OrderDetail',
      //   params: {
      //     id: orderId,
      //   }
      // });
       let route = this.$router.resolve({
          name: 'OrderDetail',
          params: {
            id: orderId,
          },
          query: {
            orderList: true,
          },
        });
        window.open(route.href, '_blank')
    },
  },
};
</script>

<style scoped>
/deep/ tbody td {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

</style>